export type Notification = {
  messageCount: number
  requestedCount: number
  contributionCount: number
  messageSendableCount: {
    count: number
    unlimited: boolean
  }
}

export const EMPTY_NOTIFICATION: Notification = {
  messageCount: 0,
  requestedCount: 0,
  contributionCount: 0,
  messageSendableCount: {
    count: 0,
    unlimited: false,
  },
}
